// extracted by mini-css-extract-plugin
export default {"container":"StageSelectBox_container__vIobl","inlineValue":"StageSelectBox_inlineValue__JffvK"};